import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const RingOuter = styled.div`
  width:${p => p.$size}px;height:${p => p.$size}px;border-radius:50%;
  background:conic-gradient(${p => p.$color} ${p => p.$pct}%, ${p => p.theme.colors.border} ${p => p.$pct}%);
  display:flex;align-items:center;justify-content:center;margin:0 auto;
`;
const Inner = styled.div`
  width:${p => p.$size - 20}px;height:${p => p.$size - 20}px;border-radius:50%;
  background:${p => p.theme.colors.surface};
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  box-shadow:${p => p.theme.shadow.card};
`;
const ScoreNum = styled.div`
  font-size:${p => p.$size > 120 ? p.theme.typography.sizes.xl : p.theme.typography.sizes.lg};
  font-weight:${p => p.theme.typography.weights.bold};
  color:${p => p.theme.colors.text.primary};
`;
const MaxText = styled.div`
  font-size:${p => p.theme.typography.sizes.xs};
  color:${p => p.theme.colors.text.muted};
`;
const RingLabel = styled.div`
  text-align:center;font-size:${p => p.theme.typography.sizes.sm};
  color:${p => p.theme.colors.text.secondary};
  margin-top:8px;font-weight:${p => p.theme.typography.weights.medium};
`;

export default function ScoreRing({ value, max = 100, color = '#6c63ff', size = 160, label, sublabel }) {
  const target = max > 0 ? Math.round((value / max) * 100) : 0;
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let start = null;
    const dur = 600;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / dur, 1);
      setPct(Math.round(p * target));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    return () => { start = null; };
  }, [target]);

  return (
    <div>
      <RingOuter $size={size} $color={color} $pct={pct}
                 aria-label={`Score: ${value} out of ${max}`}>
        <Inner $size={size}>
          <ScoreNum $size={size}>{value}</ScoreNum>
          <MaxText>/ {max}</MaxText>
          {sublabel && <MaxText>{sublabel}</MaxText>}
        </Inner>
      </RingOuter>
      {label && <RingLabel>{label}</RingLabel>}
    </div>
  );
}
